export const JST_TIMEZONE = 'Asia/Tokyo';
export const SNAPSHOT_PAGE_SIZE = 500;
export const RAW_GNSS_ANALYSIS_PADDING_HOURS = 8;
export const DEFAULT_TRACKINTEL_DIST_THRESHOLD_M = 50;
export const DEFAULT_TRACKINTEL_TIME_THRESHOLD_MIN = 8;
export const DEFAULT_TRACKINTEL_GAP_THRESHOLD_MIN = 30;
export const DEFAULT_TRACKINTEL_MERGE_STAYPOINTS_ENABLED = true;
export const DEFAULT_TRACKINTEL_MERGE_STAYPOINTS_MAX_TIME_GAP_MIN = 1;
export const DATE_QUERY_PARAM = 'date';
export const DATE_QUERY_FORMAT = 'YYYY-MM-DD';
